// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"yl","result_page":"zl","what_are_calories":"Al","title":"Bl","copy":"Cl","chart":"El","to_reach":"Fl","title_wrapper":"Gl","rhode_percent":"Hl","what_are_macro":"Il","text":"Jl","img":"Kl","macros_wrapper":"Ll","macros":"Ml","macro_item":"Nl","value":"Ol","note":"Pl","btn":"Ql","carbo_item":"Rl","faq":"Sl","faq_items":"Tl"};
    if(module.hot) {
      // 1714442365956
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  